module.exports = __webpack_public_path__ + "img/u660.26c40921.jpg";